var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.handleDataSync}},[_vm._v("Data Sync to Website")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }